import { api } from './api';

export interface Defaulter {
  studentId: string;
  studentName: string;
  admissionNumber: string;
  classLabel: string | null;
  outstandingPaise: number;
  earliestDueDate: string | null;
  overdueInvoices: number;
  lastRemindedAt: string | null;
  lastStage: string | null;
  reminderCount: number;
}

export interface Reminder {
  id: string;
  studentId: string;
  studentName: string;
  outstandingPaise: number;
  stage: string;
  outcome: string;
  sentInApp: boolean;
  sentEmail: boolean;
  sentSms: boolean;
  promisedByDate: string | null;
  note: string | null;
  sentAt: string;
}

export const REMINDER_STAGES = ['Gentle', 'Firm', 'Final'] as const;

export const recoveryApi = {
  worklist: () => api.get<Defaulter[]>('/api/recovery/worklist'),
  remind: (b: { studentIds: string[]; stage: string; sendEmail: boolean; sendSms: boolean }) =>
    api.post<{ sent: number }>('/api/recovery/remind', b),
  history: (studentId: string) => api.get<Reminder[]>(`/api/recovery/students/${studentId}/history`),
  recent: (take = 50) => api.get<Reminder[]>(`/api/recovery/recent?take=${take}`),
  promise: (reminderId: string, promisedByDate: string, note?: string) =>
    api.post<Reminder>(`/api/recovery/reminders/${reminderId}/promise`, { promisedByDate, note: note ?? null }),
};
